import { useCallback, useEffect, useState } from "react";

// UI preferences shared across screens: language (es-MX default, EN available)
// and theme (dark default, light available). Both are persisted so the login
// screen and the app agree, and mirror the marketing homepage defaults
// (dark + Spanish on first load). Mirrors the toggle behaviour in
// ~/mdo/seo/design/dashboard-mockup.html.

export type Lang = "es" | "en";
export type Theme = "light" | "dark";

const LANG_KEY = "citada.lang";
const THEME_KEY = "citada.theme";

export function useLang(): [Lang, () => void] {
  const [lang, setLang] = useState<Lang>(
    () => (localStorage.getItem(LANG_KEY) as Lang) || "es",
  );
  useEffect(() => {
    localStorage.setItem(LANG_KEY, lang);
    document.documentElement.lang = lang === "es" ? "es-MX" : "en";
  }, [lang]);
  const toggle = useCallback(
    () => setLang((l) => (l === "es" ? "en" : "es")),
    [],
  );
  return [lang, toggle];
}

export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem(THEME_KEY) as Theme) || "dark",
  );
  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);
  const toggle = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    [],
  );
  return [theme, toggle];
}
